module.exports = __webpack_public_path__ + "static/img/color-palette-11.1e343527.svg";